import { render } from "./consent_form.html?vue&type=template&id=4dc91051&external"
import script from "./consent_form.js?vue&type=script&lang=js&external"
export * from "./consent_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__